import React from "react";
import { Link } from "react-router-dom";

export default function Card({ name, description, abbreviated, image, slug }) {
  return (
    <section className="card">
      <img src={image} alt={name} className="card__image" />
      <div className="card__description">
        <h4 className="card__title">{name}</h4>
        <p className="card__text">
          {description}
          {abbreviated}
        </p>
        <Link to={`/patients/specialists/${slug}`} className="card__link">
          Подробнее →
        </Link>
      </div>
    </section>
  );
}
